// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3WOS3","inner":"Footer_inner__2lfys","nextIcon":"Footer_nextIcon__2vHQe","innerLeft":"Footer_innerLeft__1F4OR"};